import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPaginationModule} from 'ngx-pagination';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {RouterModule} from '@angular/router';
import {LoadingModule} from 'ngx-loading';
import {CommonModule} from '@angular/common';

import { routes } from './user.routing';
import { UserComponent } from './user.component';
import { UserAddComponent } from './user-add/user-add.component';
import { UserEditComponent} from './user-edit/user-edit.component';
import { UserChangepasswordComponent } from './user-changepassword/user-changepassword.component';
import { AdminChangepasswordComponent } from './admin-changepassword/admin-changepassword.component';
import { ProfileComponent } from './profile/profile.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { RolesComponent } from './roles/roles.component';
import { RightsModule} from '../rights/rights.module';
import { UserStatusComponent } from './user-status/user-status.component';
import { UserstatusPipe} from '../../pipes/userstatus.pipe';
import { UserAccessComponent } from './user-access/user-access.component';
import {UserProfileService} from '../../services/user.profile.service';
import {MaterialModule} from '../material/material.module';
import {PipesModule} from '../pipes/pipes.module';
import {TableModule} from 'primeng/table';
import { UserRegisterComponent } from './user-register/user-register.component';
import {ConfirmDialogModule, TabViewModule} from 'primeng/primeng';
import {UserFormComponent} from './user-form/user-form.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        NgxPaginationModule,
        NgxDatatableModule,
        LoadingModule,
        NgxPermissionsModule.forChild(),
        NgbModule,
        RouterModule.forChild(routes),
        RightsModule,
        MaterialModule,
        PipesModule,
        TableModule,
        TabViewModule,
        ConfirmDialogModule
    ],
    declarations: [
        UserComponent,
        UserAddComponent,
        UserChangepasswordComponent,
        AdminChangepasswordComponent,
        PermissionsComponent,
        RolesComponent,
        ProfileComponent,
        UserEditComponent,
        UserStatusComponent,
        UserstatusPipe,
        UserAccessComponent,
        UserRegisterComponent,
        UserFormComponent
    ],
    providers: [UserProfileService]
})
export class UserModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user.module.ts